import React, { useEffect } from 'react';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../styles/ImageViewer.css';

const ImageViewer = ({ images, currentIndex, onClose, onNext, onPrev }) => {
    // Handle keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            } else if (e.key === 'ArrowRight') {
                onNext();
            } else if (e.key === 'ArrowLeft') {
                onPrev();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose, onNext, onPrev]);

    if (!images || images.length === 0) return null;

    return (
        <div className="image-viewer-overlay">
            <button className="close-btn" onClick={onClose}>
                <FaTimes />
                <span className="close-text">Close</span>
            </button>

            <div className="image-viewer-container">
                <button className="nav-btn prev-btn" onClick={onPrev}>
                    <FaChevronLeft />
                </button>

                <div className="image-container">
                    <img
                        src={images[currentIndex]}
                        alt={`Gallery image ${currentIndex + 1}`}
                        className="fullscreen-image"
                    />
                    <div className="image-counter">
                        {currentIndex + 1} / {images.length}
                    </div>
                </div>

                <button className="nav-btn next-btn" onClick={onNext}>
                    <FaChevronRight />
                </button>
            </div>
        </div>
    );
};

export default ImageViewer;
